import { useAuth } from '../auth/AuthProvider';
import { useAgency } from '../agency/AgencyContext';
import type { ModuleInfo } from '../agency/modules';
import { EmptyState } from '../components/states';
import { PageHeader } from '../components/ui/page-header';

export function ComingSoonPage({ module }: { module: ModuleInfo }) {
  const { state } = useAuth();
  const { agency } = useAgency();
  const scope = state.scope;
  const subaccount = scope.kind === 'subaccount' && scope.agencyId === agency.id ? scope.subaccount : null;

  return (
    <section aria-labelledby="module-title">
      <PageHeader titleId="module-title" title={module.name} />
      <EmptyState title={`${module.name} is coming soon`}>
        {module.summary}{' '}
        {subaccount
          ? `It will work inside ${subaccount.name}.`
          : 'Choose a sub-account in “Working in” to use it there.'}
      </EmptyState>
    </section>
  );
}
